<template>
<div class="page">
  <div class="page-content">
    <div class="layoutTop"/>

    <b-container fluid>
      <b-row class="justify-content-start">
        <b-col md="3" class="showLargeScreenOnly">
          <f7-button md="3" class="button-action milkyBlockBlack"
                  @click="onRefresh()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
          </f7-button>
        </b-col>
        <b-col md="3">
          <f7-button md="3" class="button-action milkyBlockBlack"
            @click="addAccount"
            :disabled="!canAddAccount()">
            <f7-icon f7="add"></f7-icon>
            <span v-if="currentType === '1'" class="fab-label">{{ $t('administration.company_add') }}</span>
            <span v-if="currentType === '2'" class="fab-label">{{ $t('administration.user_add') }}</span>
          </f7-button>
        </b-col>
      </b-row>

      <b-row>
        <div class="col-md-12">
          <div class="adminUsersCompaniesListHeader">
            <f7-grid no-gutter>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class="pilotageLink border-top-left-radius-10px"
                  :class="{tabActive: currentType === '2', tabUnactive: currentType !== '2'}"
                  tab-link=".usersTab"
                  @click="changeCurrentType('2')" active>
                  {{ $t('administration.users_list') }}
                </f7-link>
              </f7-col>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class="pilotageLink border-top-left-radius-10px"
                  :class="{tabActive: currentType === '1', tabUnactive: currentType !== '1'}"
                  tab-link=".companiesTab"
                  @click="changeCurrentType('1')">
                  {{ $t('administration.companies_list') }}
                </f7-link>
              </f7-col>
            </f7-grid>
          </div>
        </div>
      </b-row>

      <b-row>
        <b-col>
          <f7-tabs>
            <f7-tab class="usersTab" active>
              <f7-searchbar
                class="webdatalist"
                :cancel-link="$t('common.cncl')"
                placeholder="Search in Users"
          			search-list="#users-list"
                @searchbar:search="onUsersSearch"
                @searchbar:clear="onUsersClear">
              </f7-searchbar>
              <div class="itemList">
                <spinner v-if="usersList.length === 0"></spinner>
                <users-list v-else :users="usersList"></users-list>
              </div>
            </f7-tab>
            <f7-tab class="companiesTab">
              <f7-searchbar
                class="webdatalist"
                :cancel-link="$t('common.cncl')"
                placeholder="Search in Companies"
          			search-list="#companies-list"
                @searchbar:search="onCompaniesSearch"
                @searchbar:clear="onCompaniesClear">
              </f7-searchbar>
              <div class="itemList">
                <spinner v-if="companiesList.length === 0"></spinner>
                <companies-list v-else :companies="companiesList"></companies-list>
              </div>
            </f7-tab>
          </f7-tabs>
        </b-col>
      </b-row>

    </b-container>
    <div class="toolbarPageBottomBlank"></div>
  </div>
</div>
</template>

<script>
import spinner from '@/components/common/spinner.vue'

import CompaniesList from '@/pages/administration/CompaniesList.vue'
import UsersList from '@/pages/administration/UsersList.vue'

import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'Users',
  components: {
    'companies-list': CompaniesList,
    'spinner': spinner,
    'users-list': UsersList
  },
  props: {

  },
  data () {
    return {
      companies: [],
      companiesFilterBy: '',
      companiesList: [],
      correctAccent: [],
      currentType: '2',
      users: [],
      usersFilterBy: '',
      usersList: [],
      usersOrCompanies: []
    }
  },
  created () {
    var tmpAccent = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ'
    var tmpWithoutAccent = 'aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn'
    var accent = tmpAccent.split('')
    var withoutAccent = tmpWithoutAccent.split('')
    var i = -1
    while (accent[++i]) {
      this.correctAccent[accent[i]] = withoutAccent[i]
    }
    this.correctAccent['Œ'] = 'OE'
    this.correctAccent['œ'] = 'oe'
    let that = this
    this.$engine.accounts.getUserAccountsAll()
    .then(resp => {
      that.usersOrCompanies = resp.data.userAccounts
      that.usersOrCompanies.forEach((user, key) => {
        if (user.type === '1') {
          that.companies[user.id] = user
        } else if (user.type === '2') {
          that.users[user.id] = user
        }
      })
      that.setUsers()
      that.setCompanies()
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  mounted () {
  },
  beforeDestroy () {

  },
  methods: {
    addAccount () {
      loadPage(this, {
        url: '/administration/accountAdd/' + this.currentType
      })
    },
    canAddAccount () {
      return (this.$engine.user.get().rights.admin_user_add === '1')
    },
    changeCurrentType (type) {
      if (this.currentType !== type) {
        this.currentType = type
      }
    },
    onCompaniesClear () {
      this.companiesFilterBy = ''
    },
    onUsersClear: function () {
      this.usersFilterBy = ''
    },
    onRefresh () {
      let that = this
      this.companies = []
      this.users = []
      this.$engine.accounts.getUserAccountsAll()
      .then(resp => {
        that.usersOrCompanies = resp.data.userAccounts
        that.usersOrCompanies.forEach((user, key) => {
          if (user.type === '1') {
            that.companies[user.id] = user
          } else if (user.type === '2') {
            that.users[user.id] = user
          }
        })
        that.setUsers()
        that.setCompanies()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    onCompaniesSearch (query, found) {
      this.companiesFilterBy = query
      this.setCompanies()
    },
    onUsersSearch (query, found) {
      this.usersFilterBy = query
      this.setUsers()
    },
    orderKeys (obj) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      return after
    },
    setCompanies (index = 1) {
      var companiesList = {}
      let companiesFilterBy = this.replaceAccent(this.companiesFilterBy)
      for (let companyPlusKey of Object.entries(this.companies)) {
        let company = companyPlusKey[1]
        let name = this.replaceAccent(company.Name)
        if (name.toLowerCase().includes(companiesFilterBy.toLowerCase())) {
          var firstLetter = name.substr(0, 1).toUpperCase()
          if (!companiesList.hasOwnProperty(firstLetter)) {
            companiesList[firstLetter] = []
          }
          companiesList[firstLetter].push({
            Id: company.id,
            Name: company.Name,
            Login: company.login
          })
          companiesList[firstLetter].sort((a, b) => {
            if (a === b) {
              return 0
            }
            return a.Name < b.Name ? -1 : 1
          })
        }
      }
      this.companiesList = this.orderKeys(companiesList)
    },
    setUsers (index = 1) {
      var listUsers = {}
      let usersFilterBy = this.replaceAccent(this.usersFilterBy)
      for (let userPlusKey of Object.entries(this.users)) {
        let user = userPlusKey[1]
        let name = this.replaceAccent(user.Name)
        if (name.toLowerCase().includes(usersFilterBy.toLowerCase())) {
          var firstLetter = name.substr(0, 1).toUpperCase()
          if (!listUsers.hasOwnProperty(firstLetter)) {
            listUsers[firstLetter] = []
          }
          listUsers[firstLetter].push({
            Id: user.id,
            Name: user.Name,
            Login: user.login,
            IdUserAccount: user.IdUserAccount
          })
          listUsers[firstLetter].sort((a, b) => {
            if (a === b) {
              return 0
            }
            return a.Name < b.Name ? -1 : 1
          })
        }
      }
      this.usersList = this.orderKeys(listUsers)
    },
    replaceAccent (strToTest) {
      if (!strToTest.length) {
        return strToTest
      }
      if (typeof strToTest === 'string') {
        var str = strToTest
        let correctAccent = this.correctAccent
        str = str.replace(/./g, function (i) {
          return (correctAccent[i]) ? correctAccent[i] : i
        })
        return str
      }
      return strToTest
    }
  }
}
</script>
